import React from 'react';
import { CustomButton } from '../../../../components/Button/Button';
import { Icon } from '../../../../components/Icon';
import styles from './SearchResultsControl.module.scss';
import { useTranslation } from 'react-i18next';

const SearchResultsControl = ({ current, total, handleNext, handlePrevious }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.resultsContainer}>
      <CustomButton variant="link" className={styles.arrowBtn} disabled={current?.index === 0} onClick={handlePrevious} ariaLabel={t('accessibility.increment')}>
        <Icon src="increment" className={styles.arrowIcon} />
      </CustomButton>
      <div className={styles.amountContainer}>{current && total && <span>{`${current?.index + 1} / ${total?.length}`}</span>}</div>
      <CustomButton variant="link" className={styles.arrowBtn} disabled={current?.index === total?.length - 1} onClick={handleNext} ariaLabel={t('accessibility.decrement')}>
        <Icon src="decrement" className={styles.arrowIcon} />
      </CustomButton>
    </div>
  );
};

export default SearchResultsControl;
